/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Members } from '../models/members';
@Injectable({
  providedIn: 'root',
})
class MembersService extends __BaseService {
  static readonly getAllMembersPath = '/members';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Get the list of all members
   */
  getAllMembersResponse(): __Observable<__StrictHttpResponse<Array<Members>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/members`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Members>>;
      })
    );
  }
  /**
   * @return Get the list of all members
   */
  getAllMembers(): __Observable<Array<Members>> {
    return this.getAllMembersResponse().pipe(
      __map(_r => _r.body as Array<Members>)
    );
  }
}

module MembersService {
}

export { MembersService }
